import React, {FC, useEffect, useState} from "react";
import {Modal, Table} from "antd";
import {authAttemptResource} from "../actions";
import {AuthAttemptResource} from "/react4xp/parts/language-switcher/language-switcher.type";
import * as dayjs from "dayjs";

const HistoryModal: FC<any> = (props: any) => {
    const [isLoading, setIsLoading] = useState(true);
    const [dataSource, setDataSource] = useState<AuthAttemptResource[]>([]);

    const columns = [
        {
            title: 'Дата',
            dataIndex: 'attemptedAt',
            key: 'attemptedAt',
            render: date => dayjs(date).format('DD.MM.YYYY HH:mm:ss')
        },
        {
            title: 'Сообщение',
            dataIndex: 'successful',
            key: 'successful',
            render: successful => successful ? 'Успешная авторизация' : 'Ошибка при авторизации'
        },
    ];

    useEffect(() => {
        authAttemptResource(props.user.login).then(
            value => {
                if (value.data) {
                    setDataSource(value.data);
                }
            }
        ).finally(
            () => setIsLoading(false)
        )
    }, [props.open]);

    return (
        <Modal
            title="История входа"
            open={props.open}
            onCancel={props.close}
            footer={null}
            width="80%"
        >
            <div className="my-3">
                <Table dataSource={dataSource} columns={columns} pagination={false} loading={isLoading} />
            </div>
        </Modal>
    );
};

export default HistoryModal;
